import {
    ARTICLE_FETCH_FAILURE,
    ARTICLE_FETCH_REQUEST,
    ARTICLE_FETCH_SUCCESS,
    ArticleFetchFailureAction,
    ArticleFetchRequestAction,
    ArticleFetchSuccessAction,
    FEEDBACK_SUBMIT,
    FeedbackSubmitAction,
} from 'mk2/apps/wiki/containers/Article/Article.actions';
import { initialArticleState } from 'mk2/apps/wiki/containers/Article/Article.constants';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface ArticleState {
    articleId: number | null;
    loadingState: LoadingState;
    errorMessage: string;
    feedbackSubmitted: boolean;
}

export interface ArticlesState {
    [key: string]: ArticleState;
}

const initialArticlesState: ArticlesState = {};

declare type ArticlesReducerAction =
    ArticleFetchRequestAction
    | ArticleFetchSuccessAction
    | ArticleFetchFailureAction
    | FeedbackSubmitAction;

export const articlesReducer: Reducer<ArticlesState> = (state = initialArticlesState, action: ArticlesReducerAction) => {
    switch (action.type) {
        case ARTICLE_FETCH_REQUEST:
        case ARTICLE_FETCH_FAILURE: {
            const key = `${action.categorySlug}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });
        }

        case FEEDBACK_SUBMIT: {
            const key = `${action.categorySlug}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleState, {
                    feedbackSubmitted: true,
                }),
            });
        }

        case ARTICLE_FETCH_SUCCESS: {
            const key = `${action.categorySlug}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleState, {
                    articleId: action.response.result.article,
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });
        }

        default:
            return state;
    }
};

export default articlesReducer;
